// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3Q4Tq","title":"InfoRow_title__2wniE"};